<span
  *ngIf="prefix"
  class="uni-list-content-item__pefix"
>
  {{ prefix }}:
</span>
<ng-content></ng-content>
